/* Winterfeldt – Schnellkauf ueber die Warenkorb-Pille auf Produktkarten.
   Legt das Produkt still in den Warenkorb: Die grosse Warenkorb-Leiste oeffnet
   sich NICHT, stattdessen zaehlt die Zahl am Warenkorb-Symbol oben hoch.
   - Pille bei einer Variante: <form data-wf-kauf> (snippets/wf-kauf-pille.liquid)
   - Pille bei mehreren Varianten (z. B. Farben) ist NICHT betroffen: sie oeffnet das
     Schnellkauf-Fenster des Themes, danach verhaelt sich alles wie gewohnt. */
(() => {
  if (window.__wfKauf) return;
  window.__wfKauf = true;

  const HAKEN = '<svg class="wf-kauf__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function zaehlerSetzen(anzahl, neu) {
    document.querySelectorAll('.wf-head__icon[href$="/cart"]').forEach((link) => {
      let z = link.querySelector('.wf-head__count');
      if (!z) {
        z = document.createElement('span');
        z.className = 'wf-head__count';
        link.appendChild(z);
      }
      z.textContent = anzahl;
      z.hidden = anzahl === 0;
      link.setAttribute('aria-label', 'Warenkorb (' + anzahl + ')');
      if (neu && anzahl > 0) {
        z.classList.remove('is-neu');
        void z.offsetWidth;
        z.classList.add('is-neu');
      }
    });
  }

  async function hinzufuegen(daten) {
    const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: daten });
    const j = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(res.status === 422 ? 'Mehr haben wir davon gerade leider nicht auf Lager.' : (j.description || j.message || 'Das hat leider nicht geklappt.'));
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    zaehlerSetzen(cart.item_count, true);
    /* Inhalt der Warenkorb-Leiste im Hintergrund auffrischen, ohne sie zu oeffnen */
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return cart;
  }

  function hinweis(knopf, text) {
    const karte = knopf.closest('.wf-preiszeile') || knopf.parentElement;
    let h = karte.querySelector('.wf-kauf__hinweis');
    if (!h) {
      h = document.createElement('span');
      h.className = 'wf-kauf__hinweis';
      h.setAttribute('role', 'status');
      karte.appendChild(h);
    }
    h.textContent = text;
    clearTimeout(h._t);
    h._t = setTimeout(() => { h.textContent = ''; }, 3500);
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    /* 1) Pille mit einer Variante */
    if (form.matches('[data-wf-kauf]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const knopf = form.querySelector('.wf-kauf');
      if (!knopf || knopf.getAttribute('aria-busy') === 'true') return;
      const vorher = knopf.innerHTML;
      knopf.setAttribute('aria-busy', 'true');
      try {
        await hinzufuegen(new FormData(form));
        knopf.innerHTML = HAKEN;
        knopf.classList.add('is-ok');
        setTimeout(() => { knopf.innerHTML = vorher; knopf.classList.remove('is-ok'); }, 1600);
      } catch (err) {
        hinweis(knopf, err.message);
      }
      knopf.removeAttribute('aria-busy');
    }
  }, true);
})();
